import { TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { normalizeTwoStepCode } from '@/lib/two-step-code';

export interface TwoStepCodeInputProps {
  value: string;
  onChange: (code: string) => void;
  /** Called on Enter. */
  onSubmit?: () => void;
  label?: string;
  disabled?: boolean;
  error?: string | null;
  autoFocus?: boolean;
  /** Turning two-step verification on takes only the app's code, not a recovery code. */
  appOnly?: boolean;
}

/** One box for the authenticator code and, unless `appOnly`, the recovery codes, which carry letters and dashes. */
export function TwoStepCodeInput({
  value,
  onChange,
  onSubmit,
  label,
  disabled,
  error,
  autoFocus,
  appOnly,
}: TwoStepCodeInputProps) {
  const { t } = useTranslation();
  return (
    <TextInput
      label={label ?? t('security.codeInput.label')}
      placeholder={t(
        appOnly ? 'security.codeInput.placeholderApp' : 'security.codeInput.placeholder'
      )}
      value={value}
      onChange={(e) => onChange(normalizeTwoStepCode(e.currentTarget.value))}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onSubmit?.();
        }
      }}
      autoComplete="one-time-code"
      autoCapitalize="characters"
      spellCheck={false}
      disabled={disabled}
      error={error || undefined}
      autoFocus={autoFocus}
      w="100%"
      maw={280}
      styles={{ input: { fontFamily: 'var(--mantine-font-family-monospace)', letterSpacing: 1 } }}
    />
  );
}
